﻿/**
 * @fileOverview RESAAS listing discovery based on Google Maps
 *
 * @author Chris Girard and Yin Bai
 */

/*! RESAAS - Licensed under MIT */

define([
	'jquery',
	'pubsub',
	'generalUtilities',
	'mlsData',
	'listingDiscoveryUtilityControl',
	'listingDiscoveryCommercialFormCompiled',
	'CommercialPropertyTypesData',
	'mixpanelControl'
], function listingDiscoveryMapviewControl($, pubsub, generalUtilities, mlsData, listingUtilityControl, listingDiscoveryCommercialForm, commercialPropertyTypesData) {
	'use strict';

	var module,
		map,
		elements,
		popupTriggeredByMouseClick,
		serviceSettings,
		mlsServiceSettings,
		autocompleteListener,
		mapOptions,
		listingView,
		timer,
		markers,
		infowindows,
		markerCluster,
		icons,
		values;

	module = {};
	module.private = {};
	autocompleteListener = null;
	markers = [];
	infowindows = [];
	markerCluster = {
		clearMarkers: function() {
			return false;
		}
	};

	// set sfar default location
	if (RESAAS.User2.Origin === 'SFAR') {
		values = {
			mapOptions: {
				zoom: 11,
				center: { lat: 37.83107818979716, lng: -122.48122722539061 }
			}
		};
	} else {
		values = {};
	}

	elements = {
		submitFilterSearch: '.js-btn-search-filters',
		btnGridView: '.js-grid-view',
		btnMapView: '.js-map-view',
		btnResetSearch: '.js-reset-search'
	};

	serviceSettings = {
		listingService: '/Services/ListingService.svc/json/SearchListingService',
		group: '',
		serviceResultProperty: 'SearchListingServiceResult'
	};

	mlsServiceSettings = {
		group: window.location.pathname.split('/')[2],
		listingService: '/Services/ListingService.svc/json/SearchListingServiceMLS',
		serviceResultProperty: 'SearchListingServiceMLSResult'
	};

	// MLS Override
	if (typeof mlsServiceSettings.group !== 'undefined' && mlsServiceSettings.group.length > 0) {
		$.extend(serviceSettings, mlsServiceSettings);
	}

	icons = {
		blue: {
			url: '/assets/home/images/ui/map/map-pin-blue.svg',
			size: new google.maps.Size(24, 47),
			scaledSize: new google.maps.Size(24, 47),
			origin: new google.maps.Point(0, 0),
			anchor: new google.maps.Point(12, 43)
		},
		purple: {
			url: '/assets/home/images/ui/map/map-pin-purple.svg',
			size: new google.maps.Size(24, 47),
			scaledSize: new google.maps.Size(24, 47),
			origin: new google.maps.Point(0, 0),
			anchor: new google.maps.Point(12, 43)
		},
		yellow: {
			url: '/assets/home/images/ui/map/map-pin-yellow.svg',
			size: new google.maps.Size(24, 47),
			scaledSize: new google.maps.Size(24, 47),
			origin: new google.maps.Point(0, 0),
			anchor: new google.maps.Point(12, 43)
		},
		green: {
			url: '/assets/home/images/ui/map/map-pin-green.svg',
			size: new google.maps.Size(24, 47),
			scaledSize: new google.maps.Size(24, 47),
			origin: new google.maps.Point(0, 0),
			anchor: new google.maps.Point(12, 43)
		}
	};

	module.private.setCommercialFormInputs = function setCommercialFormInputs() {
		var html = listingDiscoveryCommercialForm({ propertyTypes: commercialPropertyTypesData.browse() });
		$('.js-listings-filters-inner').html(html);
	};

	module.private.renderMap = function renderMap(e, mapOptions) {
		if (document.getElementById('map-canvas') !== null) {
			var googleControls = {
				mapTypeControl: false,
				zoomControl: true,
				zoomControlOptions: {
					position: google.maps.ControlPosition.RIGHT_BOTTOM
				},
				scaleControl: true,
				scrollwheel: false,
				streetViewControl: false,
				fullscreenControl: false
			};
			$.extend(mapOptions, googleControls);
			map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);
			google.maps.event.addListenerOnce(map, 'idle', function() {
				initialize();
			});
		}
	};

	module.private.generateListingCard = function generateListingCard(d) {
		var html, MLSGroup, MLSGroupString, listingPrice, differenceInHours, differenceInDays, gridView;

		MLSGroup = mlsData.read(d.MLSGroupType);
		MLSGroupString = MLSGroup ? MLSGroup.string : null;

		gridView = "";
		if ($(elements.btnGridView).hasClass('active-view')) {
			gridView = " grid-view";
		}

		listingPrice =
			d.Price === 0
				? ''
				: '<span><p class="listing-price text-bold">' + d.FormattedPrice + ' ' + d.CurrencyCode + '</p></span>';

		html =
			'<div itemscope itemtype="https://schema.org/Place"><a itemprop="url" href="' +
			d.SeoUrl +
			'" target="_blank" class="listing-in-list'+gridView+'" data-id="' +
			d.UniqueKey +
			'">' +
			listingPrice;

		var listingImageUrlList = listingUtilityControl.private.generateListingImageUrl(d.Images[1].Url);

		html += '<div class="listing-image-wrapper">';

		html +=
			'<img itemprop="photo" class="listing-in-list-image lazyload" data-src="' +
			listingImageUrlList.imageUrl +
			'" sizes="(min-width: 45em) 320px, 634px"' +
			'data-srcset="' +
			listingImageUrlList.imageUrl +
			' 320w, ' +
			listingImageUrlList.imageUrlResponsive +
			' 634w, ' +
			listingImageUrlList.imageUrlResponsiveRetina +
			' 1268w"/>';

		html += '<div class="listing-status-container">';

		if (d.MarketStatus === 1 && d.MLSGroupType === 0) {
			html +=
				'<span class ="re-post-label re-post-label-premarket"><span>' +
				RESAAS.Localization.Listings.PUBLIC_PRE_MARKET_LISTING_LABEL +
				'</span></span>';
		}
		if (d.IsSold) {
			if (d.ListingTransactionType === 1) {
				html +=
					'<span class="re-post-label listing-sold"><span>' +
					RESAAS.Localization.Listings.LEASED_TEXT +
					'</span></span>';
			} else {
				html +=
					'<span class="re-post-label listing-sold"><span>' +
					RESAAS.Localization.Listings.SOLD_TEXT +
					'</span></span>';
			}
		} else if (location.pathname === '/listings/sfar' && d.MarketStatus === 1 && MLSGroupString) {
			html +=
				'<span class ="re-post-label mls-premarket-featured"><span class="re-icon re-icon-xs re-icon-lock">' +
				RESAAS.Localization.Listings['PREMARKET_LABEL_' + MLSGroupString.toUpperCase()] +
				'</span></span>';
		}

		html += '</div>'; // listing-status-container
		html += '</div>'; // listing-image-wrapper

		html +=
			'<div class="listing-in-list-details" itemprop="address" itemscope itemtype="http://schema.org/PostalAddress"><p class="text-bold">';
		html += '<span itemprop="streetAddress">';
		if (d.SuiteNumber2) {
			if (d.Country === 'USA') {
				html += d.Address + ' #' + d.SuiteNumber2;
			} else {
				html += d.SuiteNumber2 + ' - ' + d.Address;
			}
		} else {
			html += d.Address;
		}
		html += '</span>';
		html +=
			', ' + '<span itemprop="addressLocality">' + d.City + '</span>' + '</p>';

		html += '<div class="listing-list-bed-and-bath-row">';
		html += '<div class="listing-list-bed-and-bath">';
		if (d.Bedrooms !== 0) {
			html += d.Bedrooms + ' ' + RESAAS.Localization.Global.BED_TEXT;
		}
		if (d.Bathrooms !== 0) {
			if (d.Bedrooms !== 0) {
				html += ' | ';
			}
			html += d.Bathrooms + ' ' + RESAAS.Localization.Global.BATH_TEXT;
		}
		html += '</div>';

		html += '<div class="listing-list-expiry text-right">'
		// expiry
		if (!d.IsSold && d.HoursToExpiry) {
			html += module.private.checkingExpiryDate(d);
		}
		html += '</div>'; // close listing-list-expiry
		html += '</div>'; // close row
		html += '<div class="listing-more-info">';

		if (d.PropertyType) {
			html += '<div class="listing-more-info-item">' + d.PropertyType + '</div>';
		}

		if (d.PropertySize) {
			html += '<div class="listing-more-info-item">' + generalUtilities.stringFormat(RESAAS.Localization.Listings.LISTING_PROPERTY_SIZE, d.PropertySize) + '</div>';
		}

		if (d.PricePerAmount) {
			html += '<div class="listing-more-info-item">' + generalUtilities.stringFormat(RESAAS.Localization.Listings.LISTING_PROPERTY_PRICE_PER_SQFT, d.FormattedPricePerAmount) + '</div>';
		}

		html += '</div>';
		html += '</div>'; // close tile
		html += '</a>';




		return html;
	};

	module.getListings = function getListings(criteriaObject, clearMarkers, populateMarkers) {
		var listingViewState;
		listingViewState = module.getListingView();
		$('.js-loading').addClass('spinner');

		$.ajax({
			url: serviceSettings.listingService,
			dataType: 'json',
			type: 'POST',
			cache: false,
			contentType: 'application/json',
			data: JSON.stringify({
				criteria: criteriaObject
			}),
			success: function success(data) {
				var returnSet = data[serviceSettings.serviceResultProperty].Data;
				clearMarkers();
				markerCluster.clearMarkers();

				if (returnSet.length === 0 || typeof returnSet.length === 'undefined') {
					$('.listings-list-no-listings').show();
				} else if (returnSet.length === 200 && listingViewState === 'map') {
					pubsub.publish('uiAction.MessageAdd', {
						message: RESAAS.Localization.Listings.MORE_MAP_RESULTS,
						type: 'warning',
						clearPreviousMessage: true
					});
				} else {
					$('.listings-list-no-listings').hide();
				}

				$('.listings-list-container .inner').empty();

				$.extend(google.maps.Marker, { re_data: {} });

				$.each(returnSet, function(i, d) {
					var icon, listingCard;

					if (d.IsSold) {
						icon = icons.yellow;
					} else {
						icon = icons.blue;

						if (d.MLSGroupType !== 0 && RESAAS.User2.Origin === 'SFAR' && d.MarketStatus === 1) {
							icon = icons.purple;
						}
						else if (d.MarketStatus === 1 && d.MLSGroupType === 0) {
							icon = icons.green;
						}
					}

					markers.push(
						new google.maps.Marker({
							position: new google.maps.LatLng(d.Latitude, d.Longitude),
							map: map,
							title: d.FormattedPrice,
							key: d.UniqueKey,
							icon: icon,
							optimized: false,
							re_data: d
						})
					);

					// add each listing to the listings-list container
					listingCard = module.private.generateListingCard(d);
					$('.listings-list-container .inner').append(listingCard);
				});

				populateMarkers();
			},
			error: function(data) {
				// show a simlpe text error
				// console.log('error' + JSON.stringify(data));
			}
		});

		setTimeout(function() {
			$('.js-loading').removeClass('spinner');
		}, 500);
	};

	module.getMarker = function getMarker(id) {
		var selectedMarker;
		$.each(markers, function(i, marker) {
			if (marker.key === id) {
				selectedMarker = marker;
			}
		});
		return selectedMarker;
	};

	module.checkingSuiteNumber = function checkingSuiteNumber(m) {
		var html = '',
			marker = {};
		if (typeof m.re_data === 'object') {
			marker = m;
		} else {
			marker.re_data = m;
		}
		if (marker.re_data.SuiteNumber2) {
			if (marker.re_data.Country === 'USA') {
				html += marker.re_data.Address + ' #' + marker.re_data.SuiteNumber2;
			} else {
				html += marker.re_data.SuiteNumber2 + ' - ' + marker.re_data.Address;
			}
		} else {
			html += marker.re_data.Address;
		}
		return html;
	};

	module.getListingView = function getListingView() {
		return $('.listings-list-container').hasClass('grid-view') ? 'grid' : 'map';
	};

	function initialize() {
		if (autocompleteListener === null) {
			var autocomplete = new google.maps.places.Autocomplete(document.getElementById('autocomplete'), {
				types: ['geocode']
			});
			autocompleteListener = google.maps.event.addListener(autocomplete, 'place_changed', function() {
				listingView = module.getListingView();
				RESAAS.MixPanel.trackEvent('Search', { type: 'listing-discovery', context: listingView });
				getAutocompleteLocation(autocomplete);
			});
		}

		function onclickRefreshSearchButton() {
			var $refreshBtn = $('.refresh-search-wrapper button');

			$refreshBtn.click(function() {
				popupTriggeredByMouseClick = false;
				clearTimeout(timer);
				fireGetListings();
				listingUtilityControl.handleRefreshBtn(false);
			});
		}

		google.maps.event.addListener(map, 'dragend', function() {
			var $toggleCheckbox = $('#toggle-refresh-checkbox');

			if ($toggleCheckbox.prop('checked')) {
				popupTriggeredByMouseClick = false;
				clearTimeout(timer);
				fireGetListings();
			} else {
				onclickRefreshSearchButton();
			}
			listingUtilityControl.handleRefreshBtn(true);
		});

		google.maps.event.addListener(map, 'dragstart', function() {
			clearTimeout(timer);
		});

		google.maps.event.addListener(map, 'zoom_changed', function() {
			var $toggleCheckbox = $('#toggle-refresh-checkbox');

			if ($toggleCheckbox.prop('checked')) {
				popupTriggeredByMouseClick = false;
				clearTimeout(timer);
				listingUtilityControl.clearOpenedInfoWindows(infowindows);
				fireGetListings();
				var mz = map.getZoom();
				var gridSize = listingUtilityControl.getGridSizeByZoom(mz);
				markerCluster.setGridSize(gridSize);

				if (mz >= 15) {
					if (markerCluster.getZoomOnClick()) {
						markerCluster.setZoomOnClick(false);
					}
				} else {
					if (!markerCluster.getZoomOnClick()) {
						markerCluster.setZoomOnClick(true);
					}
				}
				markerCluster.repaint();
			} else {
				onclickRefreshSearchButton();
			}
			listingUtilityControl.handleRefreshBtn(true);
		});

		function getAutocompleteLocation(autocomplete) {
			var autocompleteGetPlace, autocompleteLat, autocompleteLong;

			autocompleteGetPlace = autocomplete.getPlace();
			autocompleteLat = autocompleteGetPlace.geometry.location.lat();
			autocompleteLong = autocompleteGetPlace.geometry.location.lng();

			mapOptions = {
				zoom: 12,
				center: { lat: autocompleteLat, lng: autocompleteLong }
			};
			$('#js-listing-filters select').unbind('change');
			module.private.renderMap(autocomplete, mapOptions);
		}

		function fireGetListings() {
			timer = setTimeout(function() {
				searchListings();
			}, 200);
		}

		searchListings();

		function highlightTab(m) {
			var selectTab;
			$('.listing-in-list').removeClass('select-marker');
			selectTab = $('.listing-in-list[data-id="' + m.key + '"').addClass('select-marker');
			var travel = selectTab.offset().top - 164;
			window.scrollTo(0, travel);
		}

		function checkingBedBathroom(m) {
			var html = '',
				marker = {};
			if (typeof m.re_data === 'object') {
				marker = m;
			} else {
				marker.re_data = m;
			}
			if (marker.re_data.Bedrooms !== 0) {
				html += marker.re_data.Bedrooms + ' ' + RESAAS.Localization.Global.BED_TEXT;
			}
			if (marker.re_data.Bathrooms !== 0) {
				if (marker.re_data.Bedrooms !== 0) {
					html += ' | ';
				}
				html += marker.re_data.Bathrooms + ' ' + RESAAS.Localization.Global.BATH_TEXT;
			}
			return html;
		}

		function checkingExpiryDate(m, fn) {
			var differenceInHours, differenceInDays, html, marker; 
			html = '';
			marker = {};
			if (typeof m.re_data === 'object') {
				marker = m;
			} else {
				marker.re_data = m;
			}
			return fn(marker.re_data);
		}

		function populateMarkers() {
			var listingPrice, MLSGroup, MLSGroupString;

			infowindows = [];

			$.each(markers, function(i, marker) {
				MLSGroup = mlsData.read(marker.re_data.MLSGroupType);
				MLSGroupString = MLSGroup ? MLSGroup.string : null;

				listingPrice =
					marker.re_data.Price === 0
						? ''
						: '<p class="listing-price popup-price text-bold">' +
						  marker.re_data.FormattedPrice +
						  ' ' +
						  marker.re_data.CurrencyCode +
						  '</p>';

				function generateParams() {
					var html =
						'<a target="_blank" href="' +
						marker.re_data.SeoUrl +
						'" class="listing-pop-up" data-id="' +
						marker.re_data.UniqueKey +
						'">' +
						listingPrice;

					var listingImageUrlList = listingUtilityControl.private.generateListingImageUrl(marker.re_data.Images[1].Url);

					html += '<div class="listing-image-wrapper">';

					html +=
						'<img src="' +
						listingImageUrlList.imageUrl +
						'"' +
						'sizes="(min-width: 45em) 320px, 634px"' +
						'srcset="' +
						listingImageUrlList.imageUrl +
						' 320w, ' +
						listingImageUrlList.imageUrlResponsive +
						' 634w, ' +
						listingImageUrlList.imageUrlResponsiveRetina +
						' 1268w' +
						'"/>';

					html += '<div class="listing-status-container">';

					if (location.pathname !== '/listings/sfar' && marker.re_data.MarketStatus === 1 && marker.re_data.MLSGroupType === 0) {
						html +=
							'<span class ="re-post-label re-post-label-premarket"><span>' +
							RESAAS.Localization.Listings.PUBLIC_PRE_MARKET_LISTING_LABEL +
							'</span></span>';
					}

					if (marker.re_data.IsSold) {
						if (marker.re_data.ListingTransactionType === 1) {
							html +=
								'<span class="re-post-label listing-sold"><span>' +
								RESAAS.Localization.Listings.LEASED_TEXT +
								'</span></span>';
						} else {
							html +=
								'<span class="re-post-label listing-sold"><span>' +
								RESAAS.Localization.Listings.SOLD_TEXT +
								'</span></span>';
						}
					} else if (location.pathname === '/listings/sfar' && marker.re_data.MarketStatus === 1 && marker.re_data.MLSGroupType !== 0) {
						html +=
							'<span class ="re-post-label mls-premarket-featured"><span class="re-icon re-icon-xs re-icon-lock">' +
							RESAAS.Localization.Listings['PREMARKET_LABEL_' + MLSGroupString.toUpperCase()] +
							'</span></span>';
					}

					html += '</div>'; //listing-status-container
					html += '</div>'; //listing-image-wrapper

					html += '</a>';
					html +=
						'<a target="_blank" class="listing-popup-details" href="' +
						marker.re_data.SeoUrl +
						'"><p class="popup-address text-bold">' +
						module.checkingSuiteNumber(marker) +
						', ' +
						marker.re_data.City +
						'</p><div class="listing-list-bed-and-bath-row"><div class="popup-bed-and-bath">' +
						checkingBedBathroom(marker) +
						'</div><div class="listing-list-expiry text-right">';
					if (!marker.re_data.IsSold && marker.re_data.HoursToExpiry) {
						html += checkingExpiryDate(marker, module.private.checkingExpiryDate);
					}

					
					html += '</div></div>';


					html += '<div class="listing-more-info">';

					if (marker.re_data.PropertyType) {
						html += '<div class="listing-more-info-item">' + marker.re_data.PropertyType + '</div>';
					}

					if (marker.re_data.PropertySize) {
						html += '<div class="listing-more-info-item">' + generalUtilities.stringFormat(RESAAS.Localization.Listings.LISTING_PROPERTY_SIZE, marker.re_data.PropertySize) + '</div>';
					}

					if (marker.re_data.PricePerAmount) {
						html += '<div class="listing-more-info-item">' + generalUtilities.stringFormat(RESAAS.Localization.Listings.LISTING_PROPERTY_PRICE_PER_SQFT, marker.re_data.FormattedPricePerAmount) + '</div>';
					}

					html += '</div>';

					html += '</a>';

					return html;
				}

				var popup_params = generateParams();

				var infowindow = new google.maps.InfoWindow({
					content: popup_params
				});

				google.maps.event.addListener(infowindow, 'closeclick', function() {
					popupTriggeredByMouseClick = false;
				});

				google.maps.event.addListener(marker, 'click', function() {
					event.stopPropagation();
					listingUtilityControl.clearOpenedInfoWindows(infowindows);
					infowindow.open(map, marker);
					listingUtilityControl.moveMapIfElementOverlayedByNav(map, marker);
					popupTriggeredByMouseClick = true;
					RESAAS.MixPanel.trackEvent('Intent', { type: 'Listing icon' });
					clearTimeout(mouseOverTimer);
				});

				var mouseOverTimer;
				google.maps.event.addListener(marker, 'mouseover', function() {
					if (!popupTriggeredByMouseClick) {
						mouseOverTimer = setTimeout(function() {
							listingUtilityControl.clearOpenedInfoWindows(infowindows);
							infowindow.open(map, marker);
						}, 1000);
					}
				});

				google.maps.event.addListener(marker, 'mouseout', function() {
					if (!popupTriggeredByMouseClick) {
						listingUtilityControl.clearOpenedInfoWindows(infowindows);
					}
					clearTimeout(mouseOverTimer);
				});

				infowindows.push(infowindow);
			});

			markerCluster = listingUtilityControl.createMarkerCluster(map.getZoom(), markers, map);

			google.maps.event.addListener(markerCluster, 'click', function(c) {
				listingUtilityControl.clearOpenedInfoWindows(infowindows);
				markerClusterInfoWindow(markerCluster, c);
				popupTriggeredByMouseClick = true;
				RESAAS.MixPanel.trackEvent('Intent', { type: 'Listing icon' });
			});

			function markerClusterInfoWindow(markerCluster, c) {
				var m = c.getMarkers();
				var p = [];
				if (typeof m !== 'undefined') {
					if (m.length !== 0) {
						for (var i = 0; i < m.length; i++) {
							p.push(createIWindowMarkup(m[i].re_data));
						}

						if (map.getZoom() >= 15) {
							if (markerCluster.getZoomOnClick()) {
								markerCluster.setZoomOnClick(false);
							}

							var iwindow = new google.maps.InfoWindow({
								content: '<div>' + p.join(' ') + '</div>',
								position: c.getCenter()
							});

							infowindows.push(iwindow);
							listingUtilityControl.moveMapIfElementOverlayedByNav(map, iwindow);
							iwindow.open(map);
						} else {
							if (!markerCluster.getZoomOnClick()) {
								markerCluster.setZoomOnClick(true);
							}
						}
					}
				}
			}

			var mouseOverClusterTimer;
			google.maps.event.addListener(markerCluster, 'mouseover', function(c) {
				if (!popupTriggeredByMouseClick && map.getZoom() >= 15) {
					mouseOverClusterTimer = setTimeout(function() {
						listingUtilityControl.clearOpenedInfoWindows(infowindows);
						markerClusterInfoWindow(markerCluster, c);
					}, 1000);
				}
			});

			google.maps.event.addListener(markerCluster, 'mouseout', function() {
				if (!popupTriggeredByMouseClick) {
					listingUtilityControl.clearOpenedInfoWindows(infowindows);
				}
				clearTimeout(mouseOverClusterTimer);
			});

			function createIWindowMarkup(d) {
				var html, MLSGroup, MLSGroupString;

				MLSGroup = mlsData.read(d.MLSGroupType);
				MLSGroupString = MLSGroup ? MLSGroup.string : null;

				html =
					'<div class="individual-listing-container"> <a target="_blank" href="' +
					d.SeoUrl +
					'" class="listing-pop-up" data-id="' +
					d.UniqueKey +
					'">' +
					'<p class="listing-price cluster-price text-bold">' +
					d.FormattedPrice +
					' ' +
					d.CurrencyCode +
					'</p>';

				var listingImageUrlList = listingUtilityControl.private.generateListingImageUrl(d.Images[1].Url);

				html += '<div class="listing-image-wrapper">';

				html +=
					'<img class="individual-listing-image" src="' +
					listingImageUrlList.imageUrl +
					'"' +
					'sizes="(min-width: 45em) 320px, 634px"' +
					'srcset="' +
					listingImageUrlList.imageUrl +
					' 320w, ' +
					listingImageUrlList.imageUrlResponsive +
					' 634w, ' +
					listingImageUrlList.imageUrlResponsiveRetina +
					' 1268w"/>';

				html += '<div class="listing-status-container">';

				if (location.pathname !== '/listings/sfar' && d.MarketStatus === 1) {
					html +=
						'<span class="re-post-label re-post-label-premarket"><span>' +
						RESAAS.Localization.Listings.PUBLIC_PRE_MARKET_LISTING_LABEL +
						'</span></span>';
				}
				if (d.IsSold) {
					if (d.ListingTransactionType === 1) {
						html +=
							'<span class="re-post-label listing-sold"><span>' +
							RESAAS.Localization.Listings.LEASED_TEXT +
							'</span></span>';
					} else {
						html +=
							'<span class="re-post-label listing-sold"><span>' +
							RESAAS.Localization.Listings.SOLD_TEXT +
							'</span></span>';
					}
				} else if (location.pathname === '/listings/sfar' && d.MarketStatus === 1) {
					html +=
						'<span class="re-post-label mls-premarket-featured"><span class="re-icon re-icon-xs re-icon-lock">' +
						RESAAS.Localization.Listings['PREMARKET_LABEL_' + MLSGroupString.toUpperCase()] +
						'</span></span>';
				}

				html += '</div>'; // listing-status-container
				html += '</div>'; // listing-image-wrapper

				html += '</a>';

				html +=
					'<a target="_blank" class="listing-popup-details" href="' +
					d.SeoUrl +
					'"><p class="text-bold">' +
					module.checkingSuiteNumber(d) +
					', ' +
					d.City +
					'</p><div class="listing-list-bed-and-bath-row"><div class="popup-bed-and-bath">' +
					checkingBedBathroom(d) +
					'</div><div class="listing-list-expiry text-right">' +
					checkingExpiryDate(d, module.private.checkingExpiryDate) +
					'</div></div>';

				html += '<div class="listing-more-info">';

				if (d.PropertyType) {
					html += '<div class="listing-more-info-item">' + d.PropertyType + '</div>';
				}

				if (d.PropertySize) {
					html += '<div class="listing-more-info-item">' + generalUtilities.stringFormat(RESAAS.Localization.Listings.LISTING_PROPERTY_SIZE, d.PropertySize) + '</div>';
				}

				if (d.PricePerAmount) {
					html += '<div class="listing-more-info-item">' + generalUtilities.stringFormat(RESAAS.Localization.Listings.LISTING_PROPERTY_PRICE_PER_SQFT, d.FormattedPricePerAmount) + '</div>';
				}

				html += '</div>';

				html += '</a></div>';

				return html;
			}

			$('.listing-in-list').on('click', function clickFunc(e) {
				var windowWidth;
				e.stopPropagation();
				windowWidth = $(window).width();
				$('.listing-in-list').removeClass('select-marker');
				$(this).addClass('select-marker');
				popupTriggeredByMouseClick = true;
				listingUtilityControl.clearOpenedInfoWindows(infowindows);
				listingUtilityControl.openInfoWindow($(this).data('id'), infowindows, markers, map);
				if (!$('.js-grid-view').hasClass('active-view') && windowWidth > 500) {
					e.preventDefault();
				}
			});

			markerCluster.repaint();
		}

		function clearMarkers() {
			for (var i = 0; i < markers.length; i++) {
				markers[i].setMap(null);
			}
			markers.length = 0;
			markers = [];
		}
		$(elements.btnGridView).on('click', function(event) {
			switchToGridView();
		});

		$(elements.btnMapView).on('click', function(event) {
			switchToMapView();
		});

		$(elements.btnResetSearch).on('click', function(event) {
			resetSearch();
		});

		$('#js-listing-filters select, #js-listing-filters input').on('change', function(event) {
			markerCluster.clearMarkers();
			searchListings(event);
		});

		$('.listing-sort-options select').on('change', function(event) {
			searchListings(event);
		});

		$('form').submit(function(e) {
			e.preventDefault();
		});

		function switchToGridView() {
			// set up the grid layout
			$('.listings-list-container').addClass('grid-view');
			$('.listing-in-list').addClass('grid-view');
			$(elements.btnGridView).addClass('active-view');
			$(elements.btnMapView).removeClass('active-view');
			pubsub.publish('mixpanel.Intent', { type: 'grid view', from: window.pageType });
			google.maps.event.trigger(map, 'resize');
		}

		function switchToMapView() {
			// set up the grid layout
			$('.listings-list-container').removeClass('grid-view');
			$('.listing-in-list').removeClass('grid-view');
			$('#map-canvas').removeClass('grid-view');
			$(elements.btnGridView).removeClass('active-view');
			$(elements.btnMapView).addClass('active-view');
			pubsub.publish('mixpanel.Intent', { type: 'map view', from: window.pageType });
			google.maps.event.trigger(map, 'resize');
		}

		function resetSearch() {
			var listingView;

			// reset the filters
			$('select').val('');
			listingView = module.getListingView();
			RESAAS.MixPanel.trackEvent('Intent', { type: 'Reset listing search', context: listingView });
			searchListings();
		}

		function handleQueryString(type, queryObject) {
			var text = '';
			for (var key in queryObject) {
				text += '&' + key + '=' + queryObject[key];
			}

			if (history.replaceState) {
				var newurl = window.location.pathname + '?' + text;
				window.history.replaceState({ path: newurl }, '', newurl);
			}
		}

		function searchListings(event) {
			var bedFilterValue,
				bathFilterValue,
				bedQueryValue,
				bathQueryValue,
				queryObject,
				criteriaObject,
				bedroomsPlus,
				bathroomsPlus,
				searchType,
				groupName;

			bedFilterValue = $('.min-beds-filter option:selected').attr('data-value');
			bathFilterValue = $('.min-baths-filter option:selected').attr('data-value');
			bedQueryValue = $('.min-beds-filter option:selected').val();
			bathQueryValue = $('.min-baths-filter option:selected').val();

			if ($('.min-beds-filter').length &&
				$('.min-beds-filter')
					.val()
					.toString()
					.indexOf('+') === 1
			) {
				bedroomsPlus = true;
			}

			if ($('.min-baths-filter').length &&
				$('.min-baths-filter')
					.val()
					.toString()
					.indexOf('+') === 1
			) {
				bathroomsPlus = true;
			}

			if ($('.group-name-filter').prop('checked') && $('.group-name-label').text() !== '') {
				groupName = $('.group-name-filter').data('name');
			} else {
				groupName = '';
			}

			queryObject = {
				rtf: $('.recent-time-filter').val(),
				mnp: $('.min-price-filter').val(),
				mxp: $('.max-price-filter').val(),
				pr: $('.property-type-filter').val(),
				mnb: bedQueryValue,
				mnba: bathQueryValue,
				ls: $('.listing-status-filter').val(),
				z: map.getZoom(),
				la: map.getCenter().lat(),
				lo: map.getCenter().lng(),
				gn: groupName
			};

			criteriaObject = {
				MLSGroupName: serviceSettings.group,
				SortBy: $('.sort-options-dropdown').val(),
				SortDesc: $('.sort-options-dropdown option:selected').attr('data-sort'),
				MaxListingAgeInDays: $('.recent-time-filter').val(),
				PriceFrom: $('.min-price-filter').val(),
				PriceTo: $('.max-price-filter').val(),
				PropertyTypeId: $('.property-type-filter').val(),
				ShowForSaleSold: $('.listing-status-filter').val(),
				Bedrooms: bedFilterValue,
				BedroomsPlus: bedroomsPlus,
				Bathrooms: bathFilterValue,
				BathroomsPlus: bathroomsPlus,
				RecordCount: '200',
				Longitude1: map
					.getBounds()
					.getNorthEast()
					.lng()
					.toString(),
				Latitude1: map
					.getBounds()
					.getSouthWest()
					.lat()
					.toString(),
				Longitude2: map
					.getBounds()
					.getNorthEast()
					.lng()
					.toString(),
				Latitude2: map
					.getBounds()
					.getNorthEast()
					.lat()
					.toString(),
				Longitude3: map
					.getBounds()
					.getSouthWest()
					.lng()
					.toString(),
				Latitude3: map
					.getBounds()
					.getNorthEast()
					.lat()
					.toString(),
				Longitude4: map
					.getBounds()
					.getSouthWest()
					.lng()
					.toString(),
				Latitude4: map
					.getBounds()
					.getSouthWest()
					.lat()
					.toString(),
				OwnerGroupUniqueName: groupName
			};

			if ($('.search-type-filter')) {
				var searchType = $('.search-type-filter').prop('checked') ? '0' : '1';
				queryObject.st = searchType;
				criteriaObject.SearchType = searchType;
			}
			if (generalUtilities.prop(window, 'RESAAS.User2.BrokerOwner') && (generalUtilities.prop(window, 'RESAAS.User2.FirmId') !== null || generalUtilities.prop(window, 'RESAAS.User2.FirmId') !== '')) {
				var searchType = $('.broker-filter').prop('checked') ? '0' : '1';
				queryObject.bo = searchType;
				if (searchType === '0') {
					criteriaObject.FirmId = RESAAS.User2.FirmId;
				}
			}

			module.getListings(criteriaObject, clearMarkers, populateMarkers);

			handleQueryString('set', queryObject);
		}

		$(document).ready(listingUtilityControl.private.setHeights);
		$(window).on('resize', listingUtilityControl.private.setHeights);
	}

	pubsub.subscribe('data.RenderMap', module.private.renderMap);

	if (generalUtilities.prop(window, 'RESAAS.Environment.Experience') === "commercial") {
		module.private.setCommercialFormInputs();
	}

	listingUtilityControl.setMapCenterPoint(values.mapOptions);
	listingUtilityControl.private.setHeights();
	$(window).resize(generalUtilities.debounce(listingUtilityControl.hideToggleAndRefreshSearch, 300));

	$('html').on('click', function onClick() {
		listingUtilityControl.clearOpenedInfoWindows(infowindows);
	});
	$('.js-nav-container').on('click', function onClick() {
		listingUtilityControl.clearOpenedInfoWindows(infowindows);
	});

	module.private.checkingExpiryDate = function checkingExpiryDate(data) {
		var differenceInDays, html;
		html = '';
		if (data.MarketStatus === 1 && data.ExpirationDate && data.MLSGroupType === 0) {
			if (data.HoursToExpiry <= 1) {
				html += RESAAS.Localization.Listings.PUBLIC_PREMARKET_EXPIRY_HOUR;
			}
			else if (data.HoursToExpiry <= 48) {
				html += generalUtilities.stringFormat(RESAAS.Localization.Listings.PUBLIC_PREMARKET_EXPIRY_HOURS, data.HoursToExpiry);
			}
			else {
				differenceInDays = Math.floor(data.HoursToExpiry / 24);
				html += generalUtilities.stringFormat(RESAAS.Localization.Listings.PUBLIC_PREMARKET_EXPIRY_DAYS, differenceInDays);
			}
		}
		return html;
	}

	return module;
});
